import SingleSelectComponent from "../../../../components/single-select/single-select.component";
import goodMovementModel from "../../../../models/posm/goods-movement.model";
import ViewBase from "../../../view-base.view";

function MultiplePOSMLevelSelect() {
  ViewBase.call(this);

  const CATEGORY_ORDER = {
    main: 0,
    goodsType: 1,
    division: 2,
    model: 3,
    basicModel: 4
  };
  const DEFAULT_LEVEL_OPTIONS = {
    main: [],
    goodsType: [],
    division: [],
    model: [],
    basicModel: [],
  };

  let hierachyLabels = goodMovementModel.taiwanHierachyLabel;
  let movementOptions = structuredClone(DEFAULT_LEVEL_OPTIONS);

  const getFirstLevelOptions = () => {
    this.showLoading();
    goodMovementModel
      .getHierachyTreeByLevel(1, 1)
      .then((data) => {
        if (data?.length)
          movementOptions.main = data;
        else movementOptions.main = [];
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  }
  const getChildOptions = (parentCode, currentProp) => {
    this.showLoading();
    goodMovementModel
      .getHierachyTreeByParentCode(parentCode)
      .then((data) => {
        if (data?.length) {
          movementOptions[currentProp] = data;
        } else movementOptions[currentProp] = [];
      })
      .catch((err) => {
        this.handleError(err);
      })
      .finally(() => {
        this.hideLoading();
      });
  }

  const resetMovementDetailGoodtype = (currentInputGoodTypeOrder, onSelect) => {
    for (const key in CATEGORY_ORDER) {
      if (Object.hasOwnProperty.call(CATEGORY_ORDER, key)) {
        const order = CATEGORY_ORDER[key];
        if (order >= currentInputGoodTypeOrder) {
          onSelect({ [key]: { code: null, id: null, name: null } });
        }
        if (order > currentInputGoodTypeOrder) {
          movementOptions[key] = [];
        }
      }
    }
  };

  const handleSelectFunction = (selectedItems = {}, onSelect = () => { }, categoryName, categoryChildName) => (s) => {
    if (!s.code) {
      onSelect({ currentInputGoodTypeOrder: CATEGORY_ORDER[categoryName] });
      resetMovementDetailGoodtype(CATEGORY_ORDER[categoryName], onSelect);
      return
    }
    const oldCode = selectedItems[categoryName]?.code
    if (s.code != oldCode) {
      onSelect({ currentInputGoodTypeOrder: CATEGORY_ORDER[categoryChildName], [categoryName]: s });
      getChildOptions(s.id, categoryChildName);
      resetMovementDetailGoodtype(CATEGORY_ORDER[categoryChildName], onSelect);
    }
  }

  const onSelectBasicModel = (selectedItems = {}, onSelect = () => { }) => (s) => {
    onSelect({ currentInputGoodTypeOrder: CATEGORY_ORDER.basicModel });
    if (!s.code) {
      onSelect({ basicModel: { id: null, name: null, code: null } });
      return
    }
    const oldCode = selectedItems.basicModel.code;
    if (s.code != oldCode) {
      onSelect({ basicModel: s });
    }
  }

  return {
    oninit: () => {
      getFirstLevelOptions();
    },
    view: ({ attrs: { onSelect, selectedItems } }) => {
      let { currentInputGoodTypeOrder } = selectedItems
      return [
        m('.row.row-cols-5.g-2.mb-2',
          m('.col.position-relative', [
            m('label.form-label', this.getText(hierachyLabels[0][1], hierachyLabels[0][0])),
            m('.input-group',
              m(SingleSelectComponent, {
                popoverAttrs: { class: 'posm-filters' },
                items: movementOptions.main,
                selectedItem: selectedItems.main,
                checkmark: true,
                filterable: true,
                onSelect: handleSelectFunction(selectedItems, onSelect, 'main', 'goodsType'),
              }),
            ),
          ]),

          m('.col.position-relative', currentInputGoodTypeOrder >= CATEGORY_ORDER.goodsType && [
            m('label.form-label', this.getText(hierachyLabels[1][1], hierachyLabels[1][0])),
            m('.input-group',
              m(SingleSelectComponent, {
                activeIndex: (movementOptions.goodsType.findIndex((item) => { return item.code == selectedItems.goodsType.code }) + 1) || 0,
                popoverAttrs: { class: 'posm-filters' },
                allowEmpty: movementOptions.goodsType.length != 0,
                items: movementOptions.goodsType,
                selectedItem: selectedItems.goodsType,
                checkmark: true,
                filterable: true,
                onSelect: handleSelectFunction(selectedItems, onSelect, 'goodsType', 'division')
              })

            )
          ]),

          m('.col.position-relative', currentInputGoodTypeOrder >= CATEGORY_ORDER.division && [
            m('label.form-label', this.getText(hierachyLabels[2][1], hierachyLabels[2][0])),
            m('.input-group',
              m(SingleSelectComponent, {
                activeIndex: (movementOptions.division.findIndex((item) => { return item.code == selectedItems.division.code }) + 1) || 0,
                popoverAttrs: { class: 'posm-filters' },
                allowEmpty: movementOptions.division.length != 0,
                items: movementOptions.division,
                selectedItem: selectedItems.division,
                checkmark: true,
                filterable: true,
                onSelect: handleSelectFunction(selectedItems, onSelect, 'division', 'model')
              })
            ),
          ]),

          m('.col.position-relative', currentInputGoodTypeOrder >= CATEGORY_ORDER.model && [
            m('label.form-label', this.getText(hierachyLabels[3][1], hierachyLabels[3][0])),
            m('.input-group',
              m(SingleSelectComponent, {
                activeIndex: (movementOptions.model.findIndex((item) => { return item.code == selectedItems.model.code }) + 1) || 0,
                popoverAttrs: { class: 'posm-filters' },
                allowEmpty: movementOptions.model.length != 0,
                items: movementOptions.model,
                selectedItem: selectedItems.model,
                checkmark: true,
                filterable: true,
                onSelect: handleSelectFunction(selectedItems, onSelect, 'model', 'basicModel')

              })
            ),
          ]),

          m('.col.position-relative', currentInputGoodTypeOrder >= CATEGORY_ORDER.basicModel && [
            m('label.form-label', this.getText(hierachyLabels[4][1], hierachyLabels[4][0])),
            m('.input-group',
              m(SingleSelectComponent, {
                activeIndex: (movementOptions.basicModel.findIndex((item) => { return item.code == selectedItems.basicModel.code }) + 1) || 0,
                popoverAttrs: { class: 'posm-filters' },
                allowEmpty: movementOptions.basicModel.length != 0,
                items: movementOptions.basicModel,
                selectedItem: selectedItems.basicModel,
                checkmark: true,
                filterable: true,
                onSelect: onSelectBasicModel(selectedItems, onSelect)
              })
            ),
          ])
        ),
        this.getBaseViews()
      ]
    }
  }
}

export default MultiplePOSMLevelSelect